import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import appCss from "./App.module.css";

const VisionPage = lazy(() => import("./pages/VisionPage"));
const ThankYouPage = lazy(() => import("./pages/ThankYouPage"));

function PageLoader() {
  return (
    <div className={appCss.pageLoaderWrap} role="status" aria-label="Loading">
      <div className={appCss.pageLoader} />
    </div>
  );
}

function PlaceholderPage({ title, description, actionLabel = "Back to booking" }) {
  return (
    <div className={appCss.placeholderPage}>
      <div className={appCss.placeholderCard} role="alert">
        <div className={appCss.placeholderIcon}>!</div>
        <h1 className={appCss.placeholderTitle}>{title}</h1>
        <p className={appCss.placeholderText}>
          {description ||
            "This route is not available in the current build. Please use the full booking link and try again."}
        </p>
        <a href="/" className={appCss.placeholderLink}>
          {actionLabel}
        </a>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route
          path="/"
          element={
            <PlaceholderPage
              title="Something went wrong"
              description="We couldn't open this booking page because the company link is incomplete or missing. Please use the full company booking URL and try again."
              actionLabel="Refresh"
            />
          }
        />
        <Route path="/thankyou" element={<ThankYouPage />} />
        <Route path="/:slug" element={<VisionPage />} />
        <Route path="/Login" element={<PlaceholderPage title="Login" />} />
        <Route path="/ContactUs" element={<PlaceholderPage title="Contact" />} />
        <Route path="*" element={<PlaceholderPage title="Route does not exist" />} />
      </Routes>
    </Suspense>
  );
}
